<template>
    <div class="rounded-lg border border-gray-400 bg-white">
        <div v-if="$slots.header" class="w-full rounded-t-lg flex py-4 px-6 border-gray-300 border-b">
            <slot name="header" />
        </div>
        <div :class="{ 'rounded-t-lg': !$slots.header, 'rounded-b-lg': !$slots.footer }">
            <slot />
        </div>
        <div v-if="$slots.footer" class="w-full rounded-b-lg flex py-4 px-6 border-gray-300 border-t bg-gray-50">
            <slot name="footer" />
        </div>
    </div>
</template>
<script setup lang="ts">
</script>